import { render, staticRenderFns } from "./CardSmallRoom.vue?vue&type=template&id=f4023f04&scoped=true"
import script from "./CardSmallRoom.vue?vue&type=script&lang=js"
export * from "./CardSmallRoom.vue?vue&type=script&lang=js"
import style0 from "./CardSmallRoom.vue?vue&type=style&index=0&id=f4023f04&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4023f04",
  null
  
)

export default component.exports